import React, { useState } from 'react';
import { useReservations } from '../ReservationContext';

const WalkInModal = ({ isOpen, onClose }) => {
  const { loading, createWalkIn } = useReservations();

  const [walkInData, setWalkInData] = useState({
    party_size: 2,
    customer_name: 'Walk-in',
    customer_phone: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await createWalkIn(walkInData);
    if (success) {
      setWalkInData({ party_size: 2, customer_name: 'Walk-in', customer_phone: '' });
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Quick Walk-In</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form className="reservation-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Party Size *</label>
            <input
              type="number"
              min="1"
              max="20"
              value={walkInData.party_size}
              onChange={(e) => setWalkInData({ ...walkInData, party_size: parseInt(e.target.value) })}
              required
            />
          </div>

          <div className="form-group">
            <label>Guest Name</label>
            <input
              type="text"
              value={walkInData.customer_name}
              onChange={(e) => setWalkInData({ ...walkInData, customer_name: e.target.value })}
              placeholder="Walk-in"
            />
          </div>

          <div className="form-group">
            <label>Phone (optional)</label>
            <input
              type="tel"
              value={walkInData.customer_phone}
              onChange={(e) => setWalkInData({ ...walkInData, customer_phone: e.target.value })}
              placeholder="(555) 555-5555"
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Seating...' : 'Seat Walk-In'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WalkInModal;
